module.exports = __webpack_public_path__ + "img/menu.04ab64d4.svg";